import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getSamplesList.success: {
            return action.payload;
        }

        case constants.getSamplesList.error:
        case constants.getSamplesList.try: {
            return initialState;
        }

        default:
            return state;
    }
}
